/* eslint-disable import/no-anonymous-default-export */
import {
  requestPartnerDirectoryDetails,
  receivePartnerDirectoryDetails,
  PartnerDirectoryDetailsError,
} from './actions';
import * as TYPES from './constants';
import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_PARTNER_DIRECTORY_DETAILS:
      return {...state, request: true};
    case TYPES.RECEIVE_PARTNER_DIRECTORY_DETAILS:
      return {...state, data: action.payload, request: false};
    case TYPES.PARTNER_DIRECTORY_DETAILS_ERROR:
      return {...state, error: true, request: false};
    default:
      return state;
  }
};

export const fetchPartnerDirectoryDetails = uuid => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  const endpoint = `${API.opportunityLink.partner_directory}${uuid}`;
  dispatch(requestPartnerDirectoryDetails());
  try {
    return fetch(endpoint, config)
      .then(response => response.json())
      .then(json => {
        console.log('json', json);
        const data = json;
        if (Array.isArray(data) && data.length > 0) {
          const partner = data[0];
          if (partner) {
            dispatch(receivePartnerDirectoryDetails(partner));
          } else {
            dispatch(PartnerDirectoryDetailsError('Partner not found'));
          }
        }
      })
      .catch(err => {
        dispatch(PartnerDirectoryDetailsError(err));
      });
  } catch (err) {
    dispatch(PartnerDirectoryDetailsError(err));
  }
};
